import { useTradingViewChartController } from "./TradingViewChart.controller";
import { TradingViewChartPresentation } from "./TradingViewChart.pres";
import type { TradingViewChartProps } from "./TradingViewChart.types";
import { resolveTradingViewChartProps } from "./tradingView.utils";

/**
 * ATD-native TradingView chart connector. Resolves public optional props to
 * their v2-parity defaults, runs the widget lifecycle via the controller, and
 * delegates DOM rendering to the pure presentation.
 */
export const TradingViewChart = (props: TradingViewChartProps) => {
  const resolved = resolveTradingViewChartProps(props);
  useTradingViewChartController(resolved);
  return (
    <TradingViewChartPresentation
      container={resolved.container}
      height={resolved.height}
    />
  );
};
